import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Eyebrow, FadeUp, MaskLines } from "./Motion";
import { CONTACT } from "../../lib/catalog";

const FAQS = [
  ["How early do I need to book?", "We need at least three days' notice for every order. This is not an instant delivery service — the time lets us source fresh flowers and make your order by hand."],
  ["How do I place an order?", "Tap \"Book\" on the designs you like to add them to your booking list, then send the whole list to us in one WhatsApp message. You can also fill the enquiry form or call us on " + CONTACT.phone + "."],
  ["Can I choose colours and size?", "Yes. Colours, flowers and size can be adjusted to suit your occasion and space. Share your ideas when you book and we'll confirm what's possible."],
  ["Do you deliver to my home?", "Yes, we deliver to your doorstep on the booked date, packed to keep the flowers fresh. Share your address when you book and we'll confirm delivery."],
  ["Do you also set up the décor?", "Yes, we offer professional décor services. Let us know your venue and we'll plan the setup with you."],
  ["Will the flowers look exactly like the photo?", "We match the design as closely as we can. Being natural flowers, colours and sizes can vary slightly with the season and availability."],
  ["What is your return policy?", "There is no return policy. Our flowers and décor are fresh, perishable and made to order, so we can't accept returns or exchanges once an order is made or delivered."],
  ["Can I change my order after booking?", "Please contact us as early as possible. Changes depend on how far your order has progressed and may not always be possible."],
];

export const Faqs = () => (
  <section id="faqs" className="grain relative overflow-hidden bg-[#190317] py-14 sm:py-20" data-testid="faq-section">
    <div className="mx-auto grid max-w-[1440px] gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <Eyebrow>FAQs</Eyebrow>
        <h2 className="mt-4 font-display text-5xl font-medium leading-[0.95] text-[#FFF8EF] sm:text-6xl">
          <MaskLines lines={["Good to know", <span key="i" className="italic text-gold-foil">before you book.</span>]} />
        </h2>
      </div>
      <FadeUp className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-[#D4AF37]/20">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="border-[#D4AF37]/20" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="py-6 text-left font-display text-2xl font-medium text-[#FFF8EF] hover:no-underline sm:text-3xl" data-testid={`faq-trigger-${i}`}>{q}</AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-[#E8D8C8]">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </FadeUp>
    </div>
  </section>
);
